const { zipCodeRegexNumeric, onlyNumericNormalize } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 6);

exports.countryDefinition = {
  country: 'India',
  code: 'IN',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    stateCode: { label: 'Province', width: 0.5 },
    city: { label: 'Town', width: 0.5 },
    zipCode: { label: 'Postcode', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode'],
    ['zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', 'stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(6)),
      error: 'Must be 6 numbers, 110034'
    }
  ]
};
